import React from "react";

const Provision: React.FC = () => {
  return <div>Site configuration</div>;
};

export default Provision;
